// Example workflows that drive the hero run log. Synthetic demo data:
// the run log marks them as examples on the page.
const WORKFLOWS = [
  {
    id: 'onboarding',
    tab: 'New hire',
    runId: 'run_0412',
    trigger: 'HR approves J. Martinez',
    outcome: 'Ready to work on day one',
    tasks: [
      { sys: 'Entra ID', label: 'Account created', time: '0.4s' },
      { sys: 'M365', label: 'Business Premium license assigned', time: '0.8s' },
      { sys: 'SharePoint', label: 'Team folders shared', time: '1.2s' },
      { sys: 'Entra ID', label: 'Security groups applied', time: '1.6s' },
      { sys: 'Outlook', label: 'Welcome email sent', time: '2.0s' },
      { sys: 'Teams', label: 'Manager notified', time: '2.3s' },
      { sys: 'HRIS', label: 'Employee record synced', time: '2.6s' },
      { sys: 'Helpdesk', label: 'IT ticket closed', time: '2.9s' },
    ],
  },
  {
    id: 'offboarding',
    tab: 'Departure',
    runId: 'run_0413',
    trigger: 'HR records last day for R. Chen',
    outcome: 'Access closed, data handed over',
    tasks: [
      { sys: 'Entra ID', label: 'Sign-in blocked', time: '0.3s' },
      { sys: 'Entra ID', label: 'Sessions revoked on every device', time: '0.7s' },
      { sys: 'Exchange', label: 'Mailbox converted to shared', time: '1.1s' },
      { sys: 'OneDrive', label: 'Files handed to manager', time: '1.6s' },
      { sys: 'M365', label: 'License removed and reclaimed', time: '1.9s' },
      { sys: 'Entra ID', label: 'Removed from security groups', time: '2.2s' },
      { sys: 'Payroll', label: 'Final pay notified', time: '2.5s' },
      { sys: 'Helpdesk', label: 'Offboarding ticket closed', time: '2.8s' },
    ],
  },
  {
    id: 'reporting',
    tab: 'Month-end report',
    runId: 'run_0414',
    trigger: '1st of the month, 6:00 AM',
    outcome: 'Report in leadership inboxes',
    tasks: [
      { sys: 'CRM', label: 'Sales pulled', time: '0.6s' },
      { sys: 'Accounting', label: 'Invoices pulled', time: '1.1s' },
      { sys: 'Excel', label: 'Totals reconciled', time: '1.5s' },
      { sys: 'Excel', label: 'Report built', time: '2.2s' },
      { sys: 'SharePoint', label: 'Saved to the finance site', time: '2.5s' },
      { sys: 'Teams', label: 'Summary posted', time: '2.8s' },
      { sys: 'Outlook', label: 'PDF sent to leadership', time: '3.1s' },
      { sys: 'Audit log', label: 'Run recorded', time: '3.2s' },
    ],
  },
];

export default WORKFLOWS;
